var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoFavTrips(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 88,
    viewBox: "0 0 60 88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "prefix__a",
    d: "M0 90L90 90 90 0 0 0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-15 -1)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1A3966",
    d: "M54.076 67.152c-6.504 3.248-9.113 11.212-9.113 11.212s7.934 2.698 14.438-.55c6.503-3.249 9.113-11.213 9.113-11.213s-7.935-2.698-14.438.55",
    mask: "url(#prefix__b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#50939F",
    d: "M15.242 31.653C15.242 48.087 28.565 61.41 45 61.41s29.758-13.323 29.758-29.757C74.758 15.218 61.435 1.895 45 1.895S15.242 15.218 15.242 31.653",
    mask: "url(#prefix__b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D1F0FC",
    d: "M32.902 18.653c0 6.682 5.416 12.098 12.098 12.098s12.099-5.416 12.099-12.098-5.417-12.098-12.1-12.098c-6.68 0-12.097 5.416-12.097 12.098M32.902 44.652c0 6.682 5.416 12.098 12.098 12.098s12.099-5.416 12.099-12.098-5.417-12.098-12.1-12.098c-6.68 0-12.097 5.416-12.097 12.098",
    mask: "url(#prefix__b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D1F0FC",
    d: "M32 43.751c6.683 0 12.099-5.416 12.099-12.098s-5.416-12.1-12.098-12.1-12.1 5.418-12.1 12.1c0 6.682 5.418 12.098 12.1 12.098M58 43.751c6.681 0 12.098-5.416 12.098-12.098S64.68 19.553 58 19.553c-6.682 0-12.1 5.418-12.1 12.1 0 6.682 5.418 12.098 12.1 12.098",
    mask: "url(#prefix__b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M44.06 30.712c-5.932-.457-10.662-5.187-11.119-11.118 5.931.456 10.662 5.187 11.118 11.118M44.06 32.593c-.457 5.931-5.188 10.662-11.119 11.118.457-5.93 5.187-10.66 11.118-11.117M45.941 30.712c.457-5.931 5.187-10.662 11.117-11.118-.456 5.93-5.187 10.661-11.117 11.118M45.941 32.593c5.93.457 10.661 5.188 11.117 11.118-5.93-.456-10.66-5.186-11.117-11.117",
    mask: "url(#prefix__b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M43.669 31.653c-4.516 3.87-11.206 3.87-15.722 0 4.516-3.871 11.206-3.871 15.722 0M45 32.983c3.87 4.517 3.87 11.206 0 15.723-3.87-4.517-3.87-11.206 0-15.723M45 30.322c-3.87-4.517-3.87-11.206 0-15.723 3.87 4.517 3.87 11.206 0 15.723M46.33 31.653c4.517-3.871 11.206-3.871 15.724 0-4.518 3.87-11.207 3.87-15.723 0",
    mask: "url(#prefix__b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#187F69",
    d: "M39.766 31.653c0 2.89 2.343 5.234 5.234 5.234 2.89 0 5.234-2.344 5.234-5.234 0-2.891-2.343-5.235-5.234-5.235s-5.234 2.344-5.234 5.235",
    mask: "url(#prefix__b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A3966",
    d: "M44.026 88.105L45.829 88.105 45.829 61.59 44.026 61.59z",
    mask: "url(#prefix__b)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoFavTrips);
export default __webpack_public_path__ + "static/media/no_fav_trips.30269f0ebb28fc00f160980ef2230483.svg";
export { ForwardRef as ReactComponent };